import { useTranslation } from "react-i18next";
import { Navigate, useSearchParams } from "react-router";

export const OAuthExternalCallbackPage = ({
	successParam = "integrationId",
}: {
	successParam?: string;
}) => {
	const { t } = useTranslation();
	const [searchParams] = useSearchParams();
	const error = searchParams.get("error");

	if (searchParams.get(successParam)) {
		return (
			<CallbackMessage>
				{t("Thank you. You can now close this page.")}
			</CallbackMessage>
		);
	}

	if (error === "AUTHORIZATION_TIMEOUT") {
		return (
			<CallbackMessage>
				{t("The link has expired. Please request a new link.")}
			</CallbackMessage>
		);
	}

	if (!error) {
		return <Navigate to="/" />;
	}

	return (
		<CallbackMessage>
			{t("An error occurred: {{error}}", { error })}
		</CallbackMessage>
	);
};

const CallbackMessage = ({ children }: { children: string }) => {
	return (
		<div className="flex min-h-screen items-center justify-center bg-gray-50 p-6 text-center text-base text-gray-700">
			<div className="rounded-lg bg-white p-6 shadow-xs">{children}</div>
		</div>
	);
};
